import "../../styles/Pages/Conformaliter/PolitiqueLivraison.css";
import { Link } from "react-router-dom";

export default function PolitiqueRetoursRemboursements() {
  return (
    <div className="shipping-page">
      <header className="shipping-hero">
        <h1>Politique de remboursement</h1>
        <p className="shipping-update">En vigueur au {new Date().toLocaleDateString()}</p>
      </header>

      <nav className="shipping-toc" aria-label="Sommaire">
        <ul>
          <li><a href="#intro">Préambule</a></li>
          <li><a href="#retractation">10. Droit de rétractation</a></li>
          <li><a href="#retours-hors">11. Retours hors droit de rétractation</a></li>
          <li><a href="#procedure">12. Procédure de retour</a></li>
          <li><a href="#remboursements">13. Remboursements</a></li>
          <li><a href="#exclus">14. Articles exclus</a></li>
          <li><a href="#coordonnees">15. Coordonnées &amp; informations légales</a></li>
        </ul>
      </nav>

      <main className="shipping-content">
        <section id="intro" className="shipping-intro shipping-block">
          <h2>Retours et remboursements – VERTYNO</h2>
          <p>
            Cette page décrit nos conditions de <strong>rétractation, retours et remboursements</strong>.
            Pour les délais, frais et modalités de <strong>livraison</strong>, consultez la{" "}
            <Link to="/PolitiqueLivraison" className="shipping-link">
              Politique de livraison
            </Link>
            .
          </p>
          <p>
            En passant commande sur notre site, vous acceptez l&apos;ensemble des conditions décrites ci-dessous.
          </p>
        </section>

        <section id="retractation" className="shipping-block">
          <h2>10. Droit de rétractation (conformément à la loi)</h2>
          <p>
            Conformément aux articles L221-18 et suivants du Code de la consommation, le client dispose d&apos;un délai
            de <strong>14 jours calendaires</strong> à compter de la réception de sa commande pour exercer son droit de
            rétractation, sans avoir à justifier de motif.
          </p>
          <p>Pour être éligible à un remboursement, le produit doit être :</p>
          <ul>
            <li>strictement neuf,</li>
            <li>non utilisé,</li>
            <li>non endommagé,</li>
            <li>retourné dans son emballage d&apos;origine, complet et intact.</li>
          </ul>
          <p>Les <strong>frais de retour sont à la charge du client</strong>.</p>
          <p>
            Tout produit présentant des traces d&apos;utilisation, d&apos;usure, de détérioration ou incomplet{" "}
            <strong>ne pourra pas être remboursé</strong>.
          </p>
        </section>

        <section id="retours-hors" className="shipping-block">
          <h2>11. Retours hors droit de rétractation</h2>
          <p>
            En dehors du droit légal de rétractation,{" "}
            <strong>VERTYNO n&apos;accepte pas les retours pour simple changement d&apos;avis</strong>.
          </p>
        </section>

        <section id="procedure" className="shipping-block">
          <h2>12. Procédure de retour</h2>
          <p><strong>Aucun retour ne sera accepté sans accord préalable.</strong></p>
          <p>Pour initier une demande, contactez notre service client à :</p>
          <p>
            📧 <a href="mailto:contact@vertyno.com" className="shipping-link">contact@vertyno.com</a>
          </p>
          <p>
            Si la demande est acceptée, les instructions de retour vous seront communiquées par email.
          </p>
          <p>Le produit devra être expédié <strong>dans un délai de 3 jours ouvrés</strong> après validation.</p>
        </section>

        <section id="remboursements" className="shipping-block">
          <h2>13. Remboursements</h2>
          <p>
            Une fois le produit retourné et inspecté, le remboursement sera effectué{" "}
            <strong>sous 5 jours ouvrés</strong>, via le mode de paiement utilisé lors de l&apos;achat.
          </p>
          <p>
            VERTYNO se réserve le droit de refuser un remboursement ou d&apos;appliquer une décote en cas de non-respect
            des conditions ci-dessus.
          </p>
        </section>

        <section id="exclus" className="shipping-block">
          <h2>14. Articles exclus</h2>
          <p>
            Les articles personnalisés ou réalisés sur mesure ne sont ni repris ni échangés, conformément à l&apos;article
            L221-28 du Code de la consommation.
          </p>
        </section>

        <section id="coordonnees" className="shipping-block">
          <h2>15. Coordonnées &amp; informations légales</h2>
          <p>
            <strong>Nom commercial :</strong> VERTYNO<br />
            <strong>Forme juridique :</strong> SASU<br />
            <strong>Dénomination sociale :</strong> VERTYNO<br />
            <strong>Adresse :</strong> 9 Allée Gabriel Zirnhelt, 93110 Rosny-sous-Bois<br />
            <strong>Email :</strong>{" "}
            <a href="mailto:contact@vertyno.com" className="shipping-link">contact@vertyno.com</a><br />
            <strong>Téléphone :</strong> 06 61 05 05 71<br />
            <strong>SIREN :</strong> 927 887 489<br />
            <strong>SIRET :</strong> 927 887 489 00015<br />
            <strong>TVA intracommunautaire :</strong> FR32927887489<br />
            <strong>Code APE :</strong> 4690Z<br />
            <strong>Service client :</strong> du lundi au vendredi, horaires de bureau.
          </p>
        </section>

        <section className="shipping-block shipping-block--crosslink">
          <h2>Livraison et expédition</h2>
          <p>
            Zones, frais, délais (3 à 7 jours ouvrés au total), transporteurs et suivi : voir la{" "}
            <Link to="/PolitiqueLivraison" className="shipping-link">
              Politique de livraison
            </Link>
            .
          </p>
        </section>
      </main>
    </div>
  );
}
